export const styles = {
  withholdContainer: {
    position: 'absolute',
    top: 40,
    right: 40,
  },
  withoutCheckbox: {
    display: 'inline-block',
    verticalAlign: 'middle',
    marginRight: 20,
    marginLeft: 20,
  },
  withoutLabel: {
    display: 'inline-block',
    fontSize: 18,
    verticalAlign: 'middle',
    margin: 0,
    marginRight: 20,
    marginLeft: 20,
    fontWeight: 'normal',
  },
}
